import React, { useState, useEffect, useRef } from "react";
import { styled } from '@mui/material/styles';
import { Typography} from '@mui/material';
import { colors } from '../../../assets/Color/Color';


const ResponsiveHeading = styled(Typography)(({ theme }) => ({
  marginBottom: '24px',
  color: colors.blueButton,
  fontFamily: 'Sansation, sans-serif',
  fontWeight: 'bold',
  fontSize: '2rem',
  opacity: 0,
  transition: 'opacity 1s ease-in-out',
  [theme.breakpoints.down('sm')]: {
    fontSize: '1.5rem',
    marginBottom: '14px',
    marginTop: '100px',
  },
  '&.fade-in': {
    opacity: 1,
  },
}));

// Company logos 
const companies = [
 { name: "Right Side Capital Management", logo: "../../img/newhome/RsLogo.png", alt: "Right Side Capital Management", width: '277px', height: '65px', mobileWidth: '127px', mobileHeight: '50px' },
  { name: "Jumpstart Foundry", logo: "../../img/newhome/jumpstart.png", alt: "Jumpstart Foundry", width: '280px', height: '48px', mobileWidth: '128px', mobileHeight: '22px' },
  { name: "Seattle Children's Hospital", logo: "../../img/newhome/seattlechildrenslogo.svg", alt: "Seattle Children's Hospital", width: '277px', height: '118px', mobileWidth: '104px', mobileHeight: '54px' },
  { name: "Microsoft For Startups", logo: "../../img/newhome/microsoftlogo.svg", alt: "Microsoft For Startups", width: '229px', height: '59px', mobileWidth: '105px', mobileHeight: '27px' },
  {name: "BBB",  logo: "../../img/newhome/bbblogo.svg", alt: "BBB", width: '90px', height: '90px', mobileWidth: '60px', mobileHeight: '50px' },
  { name: "Life Science Washington Institute", logo: "../../img/newhome/life.png", alt: "Life Science Washington Institute", width: '250px', height: '80px', mobileWidth: '128px', mobileHeight: '40px' },
  {name: "SafKan Health",  logo: "../../img/newhome/safkan.png", alt: "SafKan Health", width: '160px', height: '55px', mobileWidth: '80px', mobileHeight: '54px' },
  { name: "Statlink", logo: "../../img/newhome/statlinklogo.svg", alt: "Statlink", width: '120px', height: '90px', mobileWidth: '80px', mobileHeight: '50px' },  
  { name: "Boston Children's Hospital", logo: "/img/newhome/bch.svg", alt: "Boston Children's Hospital", width: '160px', height: '120px', mobileWidth: '80px', mobileHeight: '54px' },
  { name: "Harvard Medical School", logo: "/img/newhome/harvard.svg", alt: "Harvard Medical School", width: '120px', height: '120px', mobileWidth: '80px', mobileHeight: '50px' },

];

const SCROLL_DURATION = 30; // seconds

const TrustedBy: React.FC = () => {
    // Duplicate the list for seamless infinite scroll
    const logos = [...companies, ...companies];

    return (
        <section style={{ background: "transparent", padding: "2rem 0" }}>
             <ResponsiveHeading
        variant="h3"
        gutterBottom
        align="center"
        className={ 'fade-in' }
      >
       Trusted By
      </ResponsiveHeading>
            
            <div
                style={{
                    overflow: "hidden",
                    width: "100%",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        width: "max-content",
                        animation: `scroll ${SCROLL_DURATION}s linear infinite`,
                    }}
                >
                    {logos.map((company, idx) => (
                        <div
                            key={idx}
                            style={{
                                flex: "0 0 auto",
                                width: 160,
                                height: 80,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                margin: "0 2rem",
                                filter: "grayscale(1)",
                                opacity: 0.8,
                            }}
                        >
                            <img
                                src={company.logo}
                                alt={company.name}
                                style={{ maxHeight: "60px", maxWidth: "120px", objectFit: "contain" }}
                            />
                        </div>
                    ))}
                </div>
            </div>
            <style>
                {`
                    @keyframes scroll {
                        0% { transform: translateX(0); }
                        100% { transform: translateX(-50%); }
                    }
                `}
            </style>
        </section>
    );
};

export default TrustedBy;